/** Angular Imports. */
import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Dates } from 'app/core/utils/dates';

/** Customer Services. */
import { OrganizationService } from 'app/organization/organization.service';
import { SettingsService } from 'app/settings/settings.service';
import { STANDALONE_SHARED_IMPORTS } from 'app/standalone-shared.module';

@Component({
  selector: 'LOSx-settle-cash',
  templateUrl: './settle-cash.component.html',
  styleUrls: ['./settle-cash.component.scss'],
  imports: [
    ...STANDALONE_SHARED_IMPORTS
  ]
})
export class SettleCashComponent implements OnInit {
  private formBuilder = inject(UntypedFormBuilder);
  private route = inject(ActivatedRoute);
  private dateUtils = inject(Dates);
  private organizationService = inject(OrganizationService);
  private settingsService = inject(SettingsService);
  private router = inject(Router);

  /** Minimum Date allowed. */
  minDate = new Date(2000, 0, 1);
  /** Maximum Date allowed. */
  maxDate = new Date();
  /** Cashier data. */
  cashierData: any;
  /** Cashier Form. */
  settleCashForm: UntypedFormGroup;

  /**
   * Get cashier data from `Resolver`.
   * @param {FormBuilder} formBuilder Form Builder.
   * @param {ActivatedRoute} route ActivateRoute.
   * @param {Dates} dateUtils Date Utils.
   * @param {OrganizationService} organizationService Organization Service.
   * @param {SettingsService} settingsService Settings Service.
   * @param {Router} router Router.
   */
  constructor() {
    this.route.data.subscribe((data: { cashierTemplate: any }) => {
      this.cashierData = data.cashierTemplate;
    });
  }

  ngOnInit() {
    this.maxDate = this.settingsService.maxFutureDate;
    this.setCashierForm();
  }

  /**
   * Set Cashier form.
   */
  setCashierForm() {
    this.settleCashForm = this.formBuilder.group({
      office: [{ value: this.cashierData.officeName, disabled: true }],
      tellerName: [{ value: this.cashierData.tellerName, disabled: true }],
      cashier: [{ value: this.cashierData.cashierName, disabled: true }],
      assignmentPeriod: [
        {
          value:
            this.dateUtils.formatDate(this.cashierData.startDate, 'dd MMMM yyyy') +
            ' - ' +
            this.dateUtils.formatDate(this.cashierData.endDate, 'dd MMMM yyyy'),
          disabled: true
        }
      ],
      txnDate: [
        new Date(),
        Validators.required
      ],
      currencyCode: [
        '',
        Validators.required
      ],
      txnAmount: [
        '',
        Validators.required
      ],
      txnNote: [
        '',
        Validators.required
      ]
    });
  }

  /**
   * Submits Settle Cash form.
   */
  submit() {
    const settleCashFormData = this.settleCashForm.value;
    const locale = this.settingsService.language.code;
    const dateFormat = this.settingsService.dateFormat;
    const prevTxnDate: Date = this.settleCashForm.value.txnDate;
    if (settleCashFormData.txnDate instanceof Date) {
      settleCashFormData.txnDate = this.dateUtils.formatDate(prevTxnDate, dateFormat);
    }
    const data = {
      ...settleCashFormData,
      dateFormat,
      locale
    };
    this.organizationService
      .settleCash(this.cashierData.tellerId, this.cashierData.cashierId, data)
      .subscribe((response: any) => {
        this.router.navigate(['../'], { relativeTo: this.route });
      });
  }
}
